import { Module } from 'vuex';
import { signIn, getAccessToken, getIdToken, getRefreshToken } from '@/service/cognitoService';

const auth: Module<any, any> = {
  state: {
    clientID: '',
    redirectURI: '',
    accessToken: '',
    idToken: '',
    refreshToken: '',
    confirmationCode: '',
    emailToConfirm: '',
    emailToResetPassword: '',
    codeToResetPassword: '',
    myEmail: '',
    appStatus: ''
  },
  mutations: {
    setClientID (state, clientID) {
      state.clientID = clientID;
    },
    setRedirectURI (state, redirectURI) {
      state.redirectURI = redirectURI;
    },
    setAccessToken (state, accessToken) {
      state.accessToken = accessToken;
    },
    setIdToken (state, idToken) {
      state.idToken = idToken;
    },
    setRefreshToken (state, refreshToken) {
      state.refreshToken = refreshToken;
    },
    setConfirmationCode (state, confirmationCode) {
      state.confirmationCode = confirmationCode;
    },
    setEmailToConfirm (state, emailToConfirm) {
      state.emailToConfirm = emailToConfirm;
    },
    setEmailToResetPassword (state, emailToResetPassword) {
      state.emailToResetPassword = emailToResetPassword;
    },
    setCodeToResetPassword (state, codeToResetPassword) {
      state.codeToResetPassword = codeToResetPassword;
    },
    setMyEmail (state, myEmail) {
      state.myEmail = myEmail;
    },
    setAppStatus (state, appStatus) {
      state.appStatus = appStatus;
    }
  },
  actions: {
    setClientID ({ commit }, clientID) {
      commit('setClientID', clientID);
    },
    setRedirectURI ({ commit }, redirectURI) {
      commit('setRedirectURI', redirectURI);
    },
    async signIn ({ commit }, { email, password }) {
      await signIn(email as string, password);
      commit('setAccessToken', await getAccessToken());
      commit('setIdToken', await getIdToken());
      commit('setRefreshToken', await getRefreshToken());
    },
    setConfirmationCode ({ commit }, confirmationCode) {
      commit('setConfirmationCode', confirmationCode);
    },
    setEmailToConfirm ({ commit }, emailToConfirm) {
      commit('setEmailToConfirm', emailToConfirm);
    },
    setAccessToken ({ commit }, accessToken) {
      commit('setAccessToken', accessToken);
    },
    setIdToken ({ commit }, idToken) {
      commit('setIdToken', idToken);
    },
    setRefreshToken ({ commit }, refreshToken) {
      commit('setRefreshToken', refreshToken);
    },
    setEmailToResetPassword ({ commit }, emailToResetPassword) {
      commit('setEmailToResetPassword', emailToResetPassword);
    },
    setCodeToResetPassword ({ commit }, codeToResetPassword) {
      commit('setCodeToResetPassword', codeToResetPassword);
    },
    setMyEmail ({ commit }, myEmail) {
      commit('setMyEmail', myEmail);
    },
    setAppStatus ({ commit }, appStatus) {
      commit('setAppStatus', appStatus);
    }
  },
  getters: {
    clientID: (state) => {
      return state.clientID;
    },
    redirectURI: (state) => {
      return state.redirectURI;
    },
    accessToken: (state) => {
      return state.accessToken;
    },
    idToken: (state) => {
      return state.idToken;
    },
    refreshToken: (state) => {
      return state.refreshToken;
    },
    confirmationCode: (state) => {
      return state.confirmationCode;
    },
    emailToConfirm: (state) => {
      return state.emailToConfirm;
    },
    emailToResetPassword: (state) => {
      return state.emailToResetPassword;
    },
    codeToResetPassword: (state) => {
      return state.codeToResetPassword;
    },
    myEmail: (state) => {
      return state.myEmail;
    },
    appStatus: (state) => {
      return state.appStatus;
    }
  }
};

export default auth;
